export const getFilterBadgeItems = <T extends { value: string; label: string; dotClassName?: string }>({
  options,
  activeFilters,
  inactiveFilters,
}: {
  options: readonly T[];
  activeFilters?: readonly string[];
  inactiveFilters?: readonly string[];
}) => {
  return options
    .filter((option) => activeFilters?.includes(option.value) || inactiveFilters?.includes(option.value))
    .map(({ value, label, dotClassName }) => ({
      value,
      label,
      dotClassName,
      active: activeFilters?.includes(value) ?? false,
    }));
};

type ToggleFilterParams = {
  value: string;
  activeFilters: string[] | undefined;
  inactiveFilters: string[] | undefined;
};

export const toggleFilterState = ({ value, activeFilters, inactiveFilters }: ToggleFilterParams) => {
  // If active, move to inactive
  if (activeFilters?.includes(value)) {
    return {
      activeFilters: activeFilters.filter((v) => v !== value),
      inactiveFilters: [...(inactiveFilters || []), value],
    };
  }
  // If inactive, move to active
  else if (inactiveFilters?.includes(value)) {
    return {
      activeFilters: [...(activeFilters || []), value],
      inactiveFilters: inactiveFilters.filter((v) => v !== value),
    };
  }
  // If neither (shouldn't happen), return unchanged
  return {
    activeFilters,
    inactiveFilters,
  };
};
